import { FormControl } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
var DataTableSource = /** @class */ (function () {
    /**
     * PaginatedDataTableSource Constructor.
     */
    function DataTableSource(config) {
        this.config = config;
        /**
         * Data for admin table to render.
         */
        this.data = new BehaviorSubject(null);
        /**
         * Control for admin table search filter input field.
         */
        this.searchQuery = new FormControl();
        /**
         * Model that stores and controls currently selected table rows.
         */
        this.selectedRows = new SelectionModel(true, []);
        /**
         * Data after it has been filtered by search query.
         */
        this.filteredData = [];
    }
    DataTableSource.prototype.init = function (params) {
        var _this = this;
        this.setFilteredData(this.config.initialData);
        this.searchQuery.valueChanges
            .pipe(distinctUntilChanged())
            .subscribe(function (query) {
            _this.setFilteredData(_this.config.initialData.filter(function (item) {
                return item['name'].toLowerCase().indexOf(query.toLowerCase()) > -1;
            }));
        });
        if (this.config.matSort) {
            this.config.matSort.sortChange.subscribe(function (sort) {
                // reset to original order
                if (!sort.direction) {
                    return _this.data.next(_this.filteredData);
                }
                var sortedData = _this.filteredData.slice().sort(function (a, b) {
                    if (a[sort.active] < b[sort.active])
                        return -1;
                    if (a[sort.active] > b[sort.active])
                        return 1;
                    return 0;
                });
                if (sort.direction === 'desc') {
                    sortedData.reverse();
                }
                _this.data.next(sortedData);
            });
        }
        return this;
    };
    DataTableSource.prototype.loading = function () {
        return false;
    };
    /**
     * Refresh the data source by clearing sort and filters.
     */
    DataTableSource.prototype.refresh = function (params) {
        this.searchQuery.reset();
        this.resetSort();
        this.selectedRows.clear();
        this.setFilteredData(this.config.initialData);
    };
    DataTableSource.prototype.resetSort = function () {
        if (!this.config.matSort)
            return;
        this.config.matSort.sort({ id: '', start: 'asc', disableClear: false });
    };
    DataTableSource.prototype.setData = function (data) {
        this.config.initialData = data;
        this.setFilteredData(this.config.initialData);
    };
    DataTableSource.prototype.getData = function () {
        return this.data.value || [];
    };
    DataTableSource.prototype.setFilteredData = function (data) {
        this.filteredData = data.slice();
        this.data.next(this.filteredData);
    };
    /**
     * Check if data source does NOT have any results.
     * Will return false if paginator was not initiated yet.
     */
    DataTableSource.prototype.isEmpty = function () {
        return !this.filteredData.length;
    };
    /**
     * Check if all table rows are selected.
     */
    DataTableSource.prototype.allRowsSelected = function () {
        return this.selectedRows.selected.length &&
            this.selectedRows.selected.length === this.filteredData.length;
    };
    /**
     * Check if any rows are selected inside the table.
     */
    DataTableSource.prototype.anyRowsSelected = function () {
        return this.selectedRows.hasValue();
    };
    /**
     * Deselect all items in data source.
     */
    DataTableSource.prototype.deselectAllItems = function () {
        this.selectedRows.clear();
    };
    /**
     * Get IDs of all items selected inside data source.
     */
    DataTableSource.prototype.getSelectedItems = function () {
        return this.selectedRows.selected.map(function (item) { return item['id']; });
    };
    DataTableSource.prototype.setSelectedItems = function (items) {
        var _a;
        this.selectedRows.clear();
        (_a = this.selectedRows).select.apply(_a, items);
    };
    DataTableSource.prototype.itemIsSelected = function (id) {
        return this.selectedRows.selected.findIndex(function (item) { return item['id'] === id; }) > -1;
    };
    /**
     * Selects all rows if they are not all selected. Otherwise clear selected rows.
     */
    DataTableSource.prototype.masterToggle = function () {
        var _this = this;
        this.allRowsSelected() ?
            this.selectedRows.clear() :
            this.filteredData.forEach(function (row) { return _this.selectedRows.select(row); });
    };
    DataTableSource.prototype.connect = function () {
        return this.data;
    };
    DataTableSource.prototype.disconnect = function () {
        this.data.complete();
    };
    return DataTableSource;
}());
export { DataTableSource };
